var globalFunctions = require('./globalFunctions.js');
module.exports = {
  haderHtml: function () {
       let html = '<div class="games-table-header-holder">'+
                    '<div class="games-table-header games-table-title">'+
                        'EVENTS'+
                    '</div> '+
                    '<div class="games-table-header games-table-tree">'+
                        '<ul>'+
                            '<li>0:0</li> '+
                            '<li>1:0</li> '+
                            '<li>1:1</li>'+
                        '</ul>'+
                    '</div> '+
                    '<div class="games-table-header games-table-tree">'+
                        '<ul>'+
                            '<li>0:1</li> '+
                            '<li>2:0</li> '+
                            '<li>2:1</li>'+
                        '</ul>'+
                    '</div> '+
                    '<div class="games-table-header games-table-tree">'+
                        '<ul>'+
                            '<li>2:2</li> '+
                            '<li>1:2</li> '+
                            '<li>0:2</li>'+
                        '</ul>'+
                    '</div>'+
                '</div>';

        return html;
  },
  gamesHtml: function (index, quotes) {
    let html =  '<div class="games-table-holder" data-id="'+quotes.ID+'" data-homeTeam="'+quotes.TeamNameHome+'" data-awayTeam="'+quotes.TeamNameAway+'">'+
                    '<div class="games-table games-table-title">'+
                        '<div class="game-number">'+index+'.</div> '+quotes.TeamNameHome+' - '+quotes.TeamNameAway + '<span class="more-games more-games-span" data-modal="' + quotes.ID + '" > + </span>' +
                        '</div> '+
                        '<div class="games-table games-table-tree">'+
                            '<ul>'+
                                '<li data-betType="0:0" data-betCode="600" class="bet-choose" data-odd="'+quotes.Score00+'">'+globalFunctions.checkQuotes(quotes.Score00)+'</li> '+
                                '<li data-betType="1:0" data-betCode="610" class="bet-choose" data-odd="'+quotes.Score10+'">'+globalFunctions.checkQuotes(quotes.Score10)+'</li> '+
                                '<li data-betType="1:1" data-betCode="611" class="bet-choose" data-odd="'+quotes.Score11+'">'+globalFunctions.checkQuotes(quotes.Score11)+'</li>'+
                            '</ul>'+
                        '</div> '+
                        '<div class="games-table games-table-tree">'+
                            '<ul>'+
                                '<li data-betType="0:1" data-betCode="601" class="bet-choose" data-odd="'+quotes.Score01+'">'+globalFunctions.checkQuotes(quotes.Score01)+'</li> '+
                                '<li data-betType="2:0" data-betCode="620" class="bet-choose" data-odd="'+quotes.Score20+'">'+globalFunctions.checkQuotes(quotes.Score20)+'</li> '+
                                '<li data-betType="2:1" data-betCode="621" class="bet-choose" data-odd="'+quotes.Score21+'">'+globalFunctions.checkQuotes(quotes.Score21)+'</li>'+
                            '</ul>'+
                        '</div> '+
                        '<div class="games-table games-table-tree">'+
                            '<ul>'+
                                '<li data-betType="2:2" data-betCode="622" class="bet-choose" data-odd="'+quotes.Score22+'">'+globalFunctions.checkQuotes(quotes.Score22)+'</li> '+
                                '<li data-betType="1:2" data-betCode="612" class="bet-choose" data-odd="'+quotes.Score12+'">'+globalFunctions.checkQuotes(quotes.Score12)+'</li> '+
                                '<li data-betType="0:2" data-betCode="602" class="bet-choose" data-odd="'+quotes.Score02+'">'+globalFunctions.checkQuotes(quotes.Score02)+'</li>'+
                            '</ul>'+
                        '</div>'+
               '</div>';

    return html;
  }
};



//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/js/modules/odds/correct_score_1.js
// module id = 2008
// module chunks = 4